import { render, staticRenderFns } from "./StrataFoundations.vue?vue&type=template&id=11125d5e&"
import script from "./StrataFoundations.vue?vue&type=script&lang=js&"
export * from "./StrataFoundations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports